// src/routes/pricingUnitsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import PricingUnits from '../pages/pricingUnits/PricingUnits';
import CreatePricingUnit from '../pages/pricingUnits/CreatePricingUnit';
import EditPricingUnit from '../pages/pricingUnits/EditPricingUnit';
import ProtectedRoute from '../components/global/ProtectedRoute';

const pricingUnitsRoutes = (
    <>
        {/* Pricing Units List */}
        <Route
            path="/pricing-units"
            element={
                <ProtectedRoute requiredPermission="pricingUnits_list">
                    <PricingUnits />
                </ProtectedRoute>
            }
        />

        {/* Pricing Units Archive */}
        <Route
            path="/pricing-units/archive"
            element={
                <ProtectedRoute requiredPermission="pricingUnits_archive_list">
                    <PricingUnits />
                </ProtectedRoute>
            }
        />

        {/* Create Pricing Unit */}
        <Route
            path="/pricing-units/create"
            element={
                <ProtectedRoute requiredPermission="pricingUnits_create">
                    <CreatePricingUnit />
                </ProtectedRoute>
            }
        />

        {/* Edit Pricing Unit */}
        <Route
            path="/pricing-units/:id/edit"
            element={
                <ProtectedRoute requiredPermission="pricingUnits_edit">
                    <EditPricingUnit />
                </ProtectedRoute>
            }
        />
    </>
);

export default pricingUnitsRoutes;
